<template>
  <div class="detail">
    <el-row :gutter="40" class="mb16" style="padding: 0 20px;">
      <div class="card_summary d-s-c d-r">
        <div>
          总消费金额：<span class="red">{{ formatStr(total) }}</span
          >元
        </div>
        <div>
          余额：<span class="red">{{ formatStr(state.money.yue_money) }}</span
          >元
        </div>
        <div>
          总充值金额：<span class="red">{{
            formatStr(state.money.risk_rechange_money)
          }}</span
          >元
        </div>
        <div>
          风控总消费金额：<span class="red">{{
            formatStr(state.money.zhangdan_money)
          }}</span
          >元
        </div>
      </div>
    </el-row>

    <el-row :gutter="40" class="mb16">
      <el-col :span="10">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <h2>E签宝数据</h2>
          </div>
          <div class="d-s-c d-r line pr">
            <div class="data_temp">
              <h3>E签宝人脸</h3>
              <div class=" d-a-c d-r" style="height: 100px;">
                <div class="item">
                  <div class="name">
                    本月消费条数（条）
                  </div>
                  <div class="value">
                    {{ state.eqb_renlian_sum }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    单笔金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.price.eqb_renlian) }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    <!-- 剩余条数（条） -->
                    消费金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.money.eqb_renlian_price) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="data_temp">
              <h3>E签宝合同</h3>
              <div class=" d-a-c d-r" style="height: 100px;">
                <div class="item">
                  <div class="name">
                    本月消费条数（条）
                  </div>
                  <div class="value">
                    {{ state.eqb_hetong_sum }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    单笔金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.price.eqb_hetong) }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    消费金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.money.eqb_hetong_price) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="14">
        <el-card shadow="hover">
          <div slot="header" class="clearfix">
            <div style="display: inline-block; width: 33.3%;">
              <h2>短信（短信宝）</h2>
            </div>
            <div style="display: inline-block; width: 33.3%;">
              <h2>orc人脸识别</h2>
            </div>
          </div>
          <div class="d-s-c d-r line_1-3 pr">
            <div class="data_temp">
              <h3>短信</h3>
              <div class=" d-a-c d-r" style="height: 100px;">
                <div class="item">
                  <div class="name">
                    消费金额
                  </div>
                  <div class="value">
                    0
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    单笔金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.price.duanxin) }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    消费条数（条）
                  </div>
                  <div class="value">
                    0
                  </div>
                </div>
              </div>
            </div>
            <div class="data_temp">
              <h3>支付宝</h3>
              <div class=" d-a-c d-r" style="height: 100px;">
                <div class="item">
                  <div class="name">
                    消费金额
                  </div>
                  <div class="value">
                    0
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    单笔金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.price.orc) }}
                  </div>
                </div>
                <div class="item">
                  <div class="name">
                    消费条数（条）
                  </div>
                  <div class="value">
                    0
                  </div>
                </div>
              </div>
            </div>
            <div class="data_temp">
              <h3>OCR</h3>
              <div class=" d-a-c d-r" style="height: 100px;">
                <div class="item">
                  <div class="name">
                    消费金额（元）
                  </div>
                  <div class="value">
                    {{ formatStr(state.money.ORC_price) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="mb16">
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>顺丰物流统计</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                微派物流服务（单）
              </div>
              <div class="value">
                0
              </div>
            </div>
            <div class="item">
              <div class="name">
                微派仅物流（单）
              </div>
              <div class="value">
                0
              </div>
            </div>
            <div class="item">
              <div class="name">
                微派仅服务（单）
              </div>
              <div class="value">
                0
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>布尔天狼星</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                0
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.tianlangxin) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.bure_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="mb16">
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>百融征信报告</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.risk_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.bairong) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.risk_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>租先知</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.zxz_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.Hv2) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.zxz_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="mb16">
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>新颜</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.xy_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                <!-- 剩余条数（条） -->
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.xy_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>掌签征信报告</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.zq_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.zhengxin) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.zq_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="mb16">
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>法谡征信查询</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.fasu_query_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.fasu_query) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.fasu_query_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>法谡征信上报</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.fasu_report_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.fasu_report) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.fasu_report_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="40" class="mb16">
      <el-col :span="12">
        <el-card shadow="hover">
          <h2>先享智报</h2>
          <div class=" d-a-c d-r" style="height: 100px;">
            <div class="item">
              <div class="name">
                本月消费条数（条）
              </div>
              <div class="value">
                {{ state.liushui_sum }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                单笔金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.price.liushui) }}
              </div>
            </div>
            <div class="item">
              <div class="name">
                消费金额（元）
              </div>
              <div class="value">
                {{ formatStr(state.money.liushui_money) }}
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer
      title="设置可用额度预警阈值"
      size="31%"
      :visible.sync="drawer"
      :with-header="false"
      show-close
    >
      <template slot="title">
        <div class="custom_title">
          设置可用额度预警阈值
        </div>
      </template>
      <div class="es-body-right flex-column">
        <div class="pneumatic-remind">
          <i class="el-icon-info icon-set"></i>
          <span
            >当可用额度小于阈值时,预警通知会发送到子账号维护的安全手机、邮箱及站内信，每天提醒一次（最多连续5天)</span
          >
        </div>
        <!-- <div class="account flex-column">
          <span>账户</span>
          <span>1232132@qq.com的账户</span>
        </div> -->
        <div
          class="flex-column"
          style="line-height: 50px; margin-bottom: 10px;"
        >
          <div class="">
            <span style="color: red;">*</span>
            <span>提醒手机号</span>
          </div>
          <el-input
            type="text"
            placeholder="请输入提醒手机号"
            maxlength="11"
            v-model="controlObj.mobile"
          />
        </div>
        <div
          class="flex-column"
          style="line-height: 50px; margin-bottom: 10px;"
        >
          <div class="">
            <span style="color: red;">*</span>
            <span>预警阈值</span>
          </div>
          <el-input
            type="number"
            placeholder="请输入预警阈值"
            v-model="controlObj.notice_amount"
            ><template slot="prepend"
              >￥</template
            ></el-input
          >
        </div>
        <div
          class="flex-column"
          style="line-height: 50px; margin-bottom: 10px;"
        >
          <div class="">
            <span style="color: red;">*</span>
            <span>是否开启</span>
          </div>
          <el-switch v-model="controlObj.notice_status" />
        </div>
        <div class="bom-btn">
          <el-button
            size="small"
            style="width: 100px;"
            type="primary"
            @click="onSubmit"
            >保存</el-button
          >
          <el-button
            size="small"
            style="width: 100px;margin-left: 20px;"
            @click="drawer = false"
            >取消</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import useApi from "@/api/useApi";

export default {
  props: {},
  data() {
    return {
      time: "",
      total: "",
      state: {
        z_sum: "", //总的查询数量
        risk_sum: "", //百融查询数量
        xy_sum: "", //新颜查询数量
        zxz_sum: "", //租先知查询数量
        eqb_renlian_sum: "", //E签宝人脸识别查询数量
        eqb_hetong_sum: "", //E签宝合同查询数量
        hcd_sum: "", //浩程达查询数量
        zq_sum: "", //掌签查询数量
        name: "",
        fasu_query_sum: 0, //快速查询数量
        fasu_report_sum: 0, //快速报告查询数量
        liushui_sum: 0, //流水查询数量
        // 金额
        money: {
          risk_rechange_money: 0, //总充值金额
          zhangdan_money: 0, //风控总消费金额
          risk_money: 0, //百融消耗金额
          bure_money: 0, //布尔消耗金额
          zxz_money: 0, //租先知消耗金额
          xy_money: 0, //新颜消耗金额
          hcd_money: 0, //浩程达消耗金额
          yue_money: 0, //余额
          eqb_renlian_price: 0, //E签宝人脸消耗金额
          eqb_hetong_price: 0, //E签宝合同消耗金额
          zq_money: 0, //掌签消耗金额
          ORC_price: 0, //ORC消耗金额
          fasu_query_money: 0,
          fasu_report_money: 0,
          liushui_money: 0
        },
        price: {
          eqb_renlian: 1,
          eqb_hetong: 1,
          orc: 0.8,
          duanxin: 0,
          renlian: 1,
          tianlangxin: 2.8,
          zhengxin: 10,
          Hv2: 0,
          bairong: 0,
          fasu_query: 5,
          fasu_report: 5,
          liushui: 10
        }
      },
      drawer: false, // 风控弹窗
      controlObj: "" // 风控数据
    };
  },
  methods: {
    // 风控编辑
    async btnDrawer(obj) {
      const { data } = await useApi().getRiskNotice();
      this.controlObj = data.vars.values;
      this.drawer = true;
    },
    // 设置风控
    async onSubmit() {
      var isOpen = this.controlObj.notice_status ? 1 : 0;
      const { msg } = await useApi().update_zfb_config({
        notice_amount: this.controlObj.notice_amount, // 预警金额
        notice_status: isOpen, // 预警开关 0=关闭 1=开启
        mobile: this.controlObj.mobile // 预警通知手机号
      });
      this.$message.success(msg);
    },

    async getCashDetail() {
      const { data } = await useApi().getCashDetail();
      Object.keys(this.state).forEach(key => {
        if (key === "money") {
          Object.keys(this.state.money).forEach(k => {
            this.state.money[k] = data[key][k];
          });
        } else this.state[key] = data[key];
      });
      if (this.state.money.yue_money && this.state.money.risk_rechange_money) {
        this.total =
          this.state.money.risk_rechange_money - this.state.money.yue_money;
      }
    },
    formatStr(str /*num*/) {
      return Number(str).toFixed(2);
    }
  },
  created() {
    this.getCashDetail();
  }
};
</script>

<style lang="scss" scoped>
.bom-btn {
  width: 100%;
  position: absolute;
  bottom: 0px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: start;
  border-top: #edf1f6 solid 1px;
  background-color: white;
  padding: 10px 20px;
}

.es-body-right {
  margin: 0px 20px 0;
  font-size: 16px;
}

.account {
  margin: 10px 00px 10px;
}

.icon-set {
  color: #0566c7;
  font-size: 22px;
  margin-right: 5px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.pneumatic-remind {
  padding: 20px;
  display: flex;
  background-color: #edf1f6;
  color: #000;
}

.custom_title {
  font-size: 16px;
  color: #000000;
  padding-bottom: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  border-bottom: #dadada solid 1px;
}

.detail {
  width: 99%;

  &* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .data_temp {
    padding: 10px;
    width: 50%;

    & + .data_temp {
      margin-left: 0;
    }
  }

  .card_summary {
    border-bottom: 1px solid #eee;
    line-height: 2.5;
    font-size: 16px;

    & > div + div {
      margin-left: 80px;
    }
  }

  .line {
    &::before {
      content: "";
      display: block;
      width: 0;
      height: 90%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateY(-50%);
      border: 1px dashed #d1dfec;
    }
  }

  .line_1-3 {
    &::before {
      content: "";
      display: block;
      width: 0;
      height: 90%;
      position: absolute;
      top: 50%;
      left: 33.3%;
      transform: translateY(-50%);
      border: 1px dashed #d1dfec;
    }

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 90%;
      position: absolute;
      top: 50%;
      left: 66.6%;
      transform: translateY(-50%);
      border: 1px dashed #d1dfec;
    }
  }

  .item {
    width: 40%;

    .value {
      text-indent: 4em;
      font-size: 16px;
      font-weight: 300;
      line-height: 60px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cash/cash/detail.vue